<template>
  <div>
    <component
      :is="answerComponentName"
      :userFormId="userFormId"
      :question="question"
      :fieldType="fieldType"
      :listId="listId"
      :isClient="true"
      :readonly="questionReadOnly"
      :isEmpty="isEmpty"
      @update:listId="$emit('update:listId', arguments[0])"
    >
    </component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextAnswer from '@/components/global/atomic/TextAnswer'
import SsnAnswer from '@/components/global/atomic/SsnAnswer'
import EmailAnswer from '@/components/global/atomic/EmailAnswer'
import DateAnswer from '@/components/global/atomic/DateAnswer'
import HDateAnswer from '@/components/global/atomic/HDateAnswer'
import DropdownAnswer from '@/components/global/atomic/DropdownAnswer'
import RadioAnswer from '@/components/global/atomic/RadioAnswer'
import NameAnswer from '@/components/global/atomic/NameAnswer'
import NumberAnswer from '@/components/global/atomic/NumberAnswer'
import CurrencyAnswer from '@/components/global/atomic/CurrencyAnswer'
import LongTextAnswer from '@/components/global/atomic/LongTextAnswer'
import CheckBoxAnswer from '@/components/global/atomic/CheckBoxAnswer'
import FileAnswer from '@/components/global/atomic/FileAnswer'
import RegexAnswer from '@/components/global/atomic/RegexAnswer'
import AltEsignAnswer from '@/components/global/atomic/AltEsignAnswer'
import answerMixin from '@/components/global/atomic/answermixin'

export default {
  name: 'AnswerField',
  mixins: [answerMixin],
  props: [ 'userFormId', 'question', 'fieldType', 'listId', 'isEmpty', 'readOnly' ],
  data () {
    return {
      menu: false,
      hovering: false
    }
  },
  components: {
    TextAnswer,
    SsnAnswer,
    EmailAnswer,
    DateAnswer,
    HDateAnswer,
    DropdownAnswer,
    RadioAnswer,
    NameAnswer,
    CurrencyAnswer,
    LongTextAnswer,
    CheckBoxAnswer,
    NumberAnswer,
    FileAnswer,
    RegexAnswer,
    AltEsignAnswer
  },
  computed: {
    ...mapGetters('userform', [
      'isReadOnly'
    ]),
    questionReadOnly () {
      return this.isReadOnly || this.readOnly || this.question.read_only;
    },
    answerComponentName () {
      if (this.fieldType.atomic_type === 'text') {
        return 'TextAnswer'
      } else if (this.fieldType.atomic_type === 'ssn') {
        return 'SsnAnswer'
      } else if (this.fieldType.atomic_type === 'email') {
        return 'EmailAnswer'
      } else if (this.fieldType.atomic_type === 'date') {
        return 'DateAnswer'
      } else if (this.fieldType.atomic_type === 'harddate') {
        return 'HDateAnswer'
      } else if (this.fieldType.atomic_type === 'dropdown') {
        return 'DropdownAnswer'
      } else if (this.fieldType.atomic_type === 'radio') {
        return 'RadioAnswer'
      } else if (this.fieldType.atomic_type === 'name') {
        return 'NameAnswer'
      } else if (this.fieldType.atomic_type === 'currency') {
        return 'CurrencyAnswer'
      } else if (this.fieldType.atomic_type === 'number') {
        return 'NumberAnswer'
      } else if (this.fieldType.atomic_type === 'textarea') {
        return 'LongTextAnswer'
      } else if (this.fieldType.atomic_type === 'checkbox') {
        return 'CheckBoxAnswer'
      } else if (this.fieldType.atomic_type === 'file') {
        return 'FileAnswer'
      } else if (this.fieldType.atomic_type === 'altesign') {
        return 'AltEsignAnswer'
      } else if (this.fieldType.atomic_type === 'regex') {
        return 'RegexAnswer'
      }
      return false;
    }
  }
}
</script>

<style>
  .input-group {
    position: relative;
    width: 100%;
  }

.input-group-btn {
  position: absolute;
  right:-25px;
  top: -10px;
  z-index: 999;
}
</style>
